<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">智能回收秤</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img style="width: 90%" class="oneBodyImgCls" src="../assets/images/hc3620_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">智能回收秤</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          智能回收秤是应用在垃圾分类过程中的可回收废品回收环节，由环卫人员在居民社区对回收物品的称重、打印回收信息纸、刷居民卡、扫描二维码等功能，实现回收物品与居民信息关联，从而实现垃圾回收兑换积分，增强居民的垃圾回收意识，促进垃圾分类规范。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">
        秤托收起：560mm(长)*450mm(宽)*800mm(高)
      </div>
      <div class="center_two_e">
        秤托展开：560mm(长)*900mm(宽)*800mm(高)
      </div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../assets/images/home_center_adorn.png">
      </div>


      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        垃圾房，垃圾车，居民社区，公共场所，小区宽阔区域
      </div>

      <div class="center_two_d">功能</div>
      <div class="center_two_f">
        <img src="../assets/images/hc3620_center_002.png">
      </div>

    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left">一</div>
        <div class="three_body_left_right">不锈钢外壳：全304不锈钢外壳，结实耐用；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">二</div>
        <div class="three_body_right_right">多接口网络连接：WiFi/3G/4G或有线网络，方便不同网络环境实施，并可支持后台远程更新升级；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">三</div>
        <div class="three_body_left_right">高清大屏触摸交互：10.1寸高清显示屏，电容触摸，交互体验；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">四</div>
        <div class="three_body_right_right">支持二维码扫码：通过扫描器扫码居民积分卡二维码，使居民身份证识别操作更便捷；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">五</div>
        <div class="three_body_left_right">热敏打印：打印回收物品的基本信息和居民信息，并生成二维码，方便扫描查看；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">六</div>
        <div class="three_body_right_right" style="text-align: right">远程维护：服务器可进行远程升级和维护。</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">七</div>
        <div class="three_body_left_right">语音播报：为刷卡提供立体声语音提示及语音播放，减少漏刷或刷卡不成功概率；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">八</div>
        <div class="three_body_right_right" style="text-align: right">高清广角摄像头：可通过拍照称重物品，通过后台进行类别判定；</div>
      </div>

    </div>

    <div class="detail_center_four">
      <img src="../assets/images/hc3620_center_003.png"/>
      <div class="center_four_text">(可定制)</div>
    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../assets/images/hc3620_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })

  },
}
</script>

<style lang="less" scoped>

@import "../assets/css/detailCommon";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 588px;

    .oneBodyImgCls {
      width: 100%;
      height: 588px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 678px;

    .oneBodyImgCls {
      width: 100%;
      height: 678px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 882px;

    .oneBodyImgCls {
      width: 100%;
      height: 882px;
    }
  }
}

.center_one_body_current {
  display: flex;

  .oneBodyImgCls {
  }
}



</style>